__turbopack_context__.v({
  "calculator": "L5dzGW_calculator",
  "consumptionEndAdornment": "L5dzGW_consumptionEndAdornment",
  "iconSelect": "L5dzGW_iconSelect",
  "innerWrapper": "L5dzGW_innerWrapper",
  "submitButton": "L5dzGW_submitButton",
});
